import { Phone } from '../api-client';

const formatPhone = (phone: Phone): string => {
  const phoneNumber = phone.number;
  const formattedNumber = `(${phoneNumber.substring(0, 3)}) ${phoneNumber.substring(3, 6)}-${phoneNumber.substring(6, 8)}-${phoneNumber.substring(8, 10)}`;
  return `${phone.countryCode} ${formattedNumber}`;
};

export default formatPhone;
